export default {
  getPopupData: (state) => state.popupData,
  isSaveLoading: (state) => state.isLoading.save,
};
